import { html, ref, when } from '@microsoft/fast-element';
import type { IndividualProjectGraphs } from './individual-projects-graphs';
import { PRODUCT_TYPE } from '../../../../utils';
import {INDIVIDUAL_PROJECT_GRAPH_TITLES, MORE_INFO_ITEMS} from '../../../../utils/enums/more-info.enum';

export enum TAB_LIST {
  GENERATION = 1,
  FLOATING_PRICE = 2,
  NODAL_BASIS = 3,
  SETTLEMENT_FORECAST = 4,
  LME_TOTAL_CARBON = 5,
  CARBON_FREE = 6,
  IMPLIED_CARBON_PRICE = 7,
}

export const IndividualProjectGraphsTemplate = html<IndividualProjectGraphs>`
  <div class="container">
    <zero-tabs class="auto-height">
      <zero-tab class="chartTab" slot="tab" @click=${(x) => x.tabSelected(TAB_LIST.GENERATION)}>
        Generation
        <more-info-icon
          :isVisible=${(x) => x.activeTab == TAB_LIST.GENERATION}
          :moreInfoItem=${() => MORE_INFO_ITEMS.GENERATION}
        ></more-info-icon>
      </zero-tab>
      ${when(
        (x) => x.selectedProductType !== PRODUCT_TYPE.RECS,
        html<IndividualProjectGraphs>`
          <zero-tab
            class="chartTab"
            slot="tab"
            @click=${(x) => x.tabSelected(TAB_LIST.FLOATING_PRICE)}
          >
            Floating Price
            <more-info-icon
              :isVisible=${(x) => x.activeTab == TAB_LIST.FLOATING_PRICE}
              :moreInfoItem=${() => MORE_INFO_ITEMS.FLOATING_PRICE}
            ></more-info-icon>
          </zero-tab>
          <zero-tab
            class="chartTab"
            slot="tab"
            @click=${(x) => x.tabSelected(TAB_LIST.NODAL_BASIS)}
          >
            Nodal Basis
            <more-info-icon
              :isVisible=${(x) => x.activeTab == TAB_LIST.NODAL_BASIS}
              :moreInfoItem=${() => MORE_INFO_ITEMS.NODAL_BASIS}
            ></more-info-icon>
          </zero-tab>
          <zero-tab
            class="chartTab"
            slot="tab"
            @click=${(x) => x.tabSelected(TAB_LIST.SETTLEMENT_FORECAST)}
          >
            Settlement Forecast
            <more-info-icon
              :isVisible=${(x) => x.activeTab == TAB_LIST.SETTLEMENT_FORECAST}
              :moreInfoItem=${() => MORE_INFO_ITEMS.SETTLEMENT_FORECAST}
            ></more-info-icon>
          </zero-tab>
        `,
      )}
      <zero-tab
        class="chartTab"
        slot="tab"
        @click=${(x) => x.tabSelected(TAB_LIST.LME_TOTAL_CARBON)}
      >
        LME + Total Carbon Reduction
        <more-info-icon
          :isVisible=${(x) => x.activeTab == TAB_LIST.LME_TOTAL_CARBON}
          :moreInfoItem=${() => MORE_INFO_ITEMS.LME_TOTAL_CARBON}
        ></more-info-icon>
      </zero-tab>
      <zero-tab class="chartTab" slot="tab" @click=${(x) => x.tabSelected(TAB_LIST.CARBON_FREE)}>
        Carbon Free Energy
        <more-info-icon
          :isVisible=${(x) => x.activeTab == TAB_LIST.CARBON_FREE}
          :moreInfoItem=${() => MORE_INFO_ITEMS.CARBON_FREE}
        ></more-info-icon>
      </zero-tab>
      <zero-tab
        class="chartTab"
        slot="tab"
        @click=${(x) => x.tabSelected(TAB_LIST.IMPLIED_CARBON_PRICE)}
      >
        Implied Carbon Price
        <more-info-icon
          :isVisible=${(x) => x.activeTab == TAB_LIST.IMPLIED_CARBON_PRICE}
          :moreInfoItem=${() => MORE_INFO_ITEMS.IMPLIED_CARBON_PRICE}
        ></more-info-icon>
      </zero-tab>

      <zero-tab-panel slot="tabpanel" class="full-height-tab">
        <generation-mwh class="auto-height" ${ref('generationGraph')}></generation-mwh>
      </zero-tab-panel>
      ${when(
        (x) => x.selectedProductType !== PRODUCT_TYPE.RECS,
        html<IndividualProjectGraphs>`
          <zero-tab-panel slot="tabpanel" class="full-height-tab">
            <floating-price class="auto-height" ${ref('floatingPriceGraph')}></floating-price>
          </zero-tab-panel>
          <zero-tab-panel slot="tabpanel" class="full-height-tab">
            <nodal-basis class="auto-height" ${ref('nodalBasisGraph')}></nodal-basis>
          </zero-tab-panel>
          <zero-tab-panel slot="tabpanel" class="full-height-tab">
            <settlement-forecast
              class="auto-height"
              ${ref('settlementForecastGraph')}
            ></settlement-forecast>
          </zero-tab-panel>
        `,
      )}
      <zero-tab-panel slot="tabpanel" class="full-height-tab">
        <lme-total-carbon-reduction
          class="auto-height"
          ${ref('lmeCarbonReductionGraph')}
        ></lme-total-carbon-reduction>
      </zero-tab-panel>
      <zero-tab-panel slot="tabpanel" class="full-height-tab">
        <carbon-free-energy
          class="auto-height"
          ${ref('carbonFreeEnergyGraph')}
        ></carbon-free-energy>
      </zero-tab-panel>
      ${when(
        (x) => x.selectedProductType !== PRODUCT_TYPE.RECS,
        html<IndividualProjectGraphs>`
          <zero-tab-panel slot="tabpanel" class="full-height-tab">
            <implied-carbon-price
              class="auto-height"
              ${ref('impliedCarbonPriceGraph')}
            ></implied-carbon-price>
          </zero-tab-panel>
        `,
      )}
      ${when(
        (x) => x.selectedProductType === PRODUCT_TYPE.RECS,
        html<IndividualProjectGraphs>`
          <zero-tab-panel slot="tabpanel" class="full-height-tab">
            <rec-implied-carbon-price
              class="auto-height"
              ${ref('recImpliedCarbonPriceGraph')}
            ></rec-implied-carbon-price>
          </zero-tab-panel>
        `,
      )}
    </zero-tabs>
  </div>
`;
